import { Chart } from 'chart.js/auto';

import { createAnnualCashflowsChart } from '../../../graphs/annual_cash_flows_chart';
import { createCumulativeAnnualCashflowsChart } from '../../../graphs/cumulative_annual_cash_flows_chart';
import { initPdfExport } from './show/pdf_export';
import './profile_filters';

$(function() {
  if (!document.getElementById('fund-id')) return;

  initGraphAndTables();
  initSpreadsheetExportForm();
  initPdfExport();
});

function initGraphAndTables() {
  const $form = $('#profile-filter');
  const $fundId = $('#fund-id').data('fund-id');
  const initialScope = document.getElementsByTagName('initial-scope')[0].dataset['scope']
  let localStorageKey = 'fund' + $fundId + 'GraphData';
  let currentCumulativeScope = initialScope;
  let currentAnnualScope = initialScope;

  if (!!localStorage.getItem(localStorageKey)) {
    createCumulativeAnnualCashflowsChart(JSON.parse(localStorage.getItem(localStorageKey)), currentCumulativeScope);
    createAnnualCashflowsChart(JSON.parse(localStorage.getItem(localStorageKey)), currentAnnualScope);
  }

  generateGraphsAndTablesFromProfilesFilter($form, $fundId, currentCumulativeScope, currentAnnualScope);

  $form.on('submit', e => {
    e.preventDefault();
    generateGraphsAndTablesFromProfilesFilter($form, $fundId, currentCumulativeScope, currentAnnualScope);
  });

  // Cumulative cashflow tabs

  $('#global-cumulative-cashflow-tab').on('click', e => {
    if (currentCumulativeScope === 'global') {
      return;
    } else {
      currentCumulativeScope = 'global';
      let existingCumulativeChart = Chart.getChart('cumulativeAnnualCashFlowChartCanvas');

      if (existingCumulativeChart != null) {
        existingCumulativeChart.destroy();
      }

      createCumulativeAnnualCashflowsChart(JSON.parse(localStorage.getItem(localStorageKey)), currentCumulativeScope);
    }
  })

  $('#individual-cumulative-cashflow-tab').on('click', e => {
    if (currentCumulativeScope === 'individual') {
      return;
    } else {
      currentCumulativeScope = 'individual';
      let existingCumulativeChart = Chart.getChart('cumulativeAnnualCashFlowChartCanvas');

      if (existingCumulativeChart != null) {
        existingCumulativeChart.destroy();
      }

      createCumulativeAnnualCashflowsChart(JSON.parse(localStorage.getItem(localStorageKey)), currentCumulativeScope);
    }
  })

  // Annual cashflow tabs

  $('#global-annual-cashflow-tab').on('click', e => {
    if (currentAnnualScope === 'global') {
      return;
    } else {
      currentAnnualScope = 'global';
      let existingAnnualChart = Chart.getChart('annualCashFlowsChartCanvas');

      if (existingAnnualChart != null) {
        existingAnnualChart.destroy();
      }

      createAnnualCashflowsChart(JSON.parse(localStorage.getItem(localStorageKey)), currentAnnualScope);
    }
  })

  $('#individual-annual-cashflow-tab').on('click', e => {
    if (currentAnnualScope === 'individual') {
      return;
    } else {
      currentAnnualScope = 'individual';
      let existingAnnualChart = Chart.getChart('annualCashFlowsChartCanvas');

      if (existingAnnualChart != null) {
        existingAnnualChart.destroy();
      }

      createAnnualCashflowsChart(JSON.parse(localStorage.getItem(localStorageKey)), currentAnnualScope);
    }
  })
}

function generateGraphsAndTablesFromProfilesFilter (form, fundId, currentCumulativeScope, currentAnnualScope) {
  $.ajax({
    url: form.attr('action'),
    type: 'GET',
    data: form.serialize(),
    dataType: 'script',
    success: function () {
      let localStorageKey = 'fund' + fundId + 'GraphData';

      let existingCumulativeChart = Chart.getChart('cumulativeAnnualCashFlowChartCanvas');
      let existingAnnualChart = Chart.getChart('annualCashFlowsChartCanvas');

      if (!!existingCumulativeChart) {
        existingCumulativeChart.destroy();
      };

      if (!!existingAnnualChart) {
        existingAnnualChart.destroy();
      };

      createCumulativeAnnualCashflowsChart(JSON.parse(localStorage.getItem(localStorageKey)), currentCumulativeScope);
      createAnnualCashflowsChart(JSON.parse(localStorage.getItem(localStorageKey)), currentAnnualScope);
    },
    error: function () {
      console.error;
    }
  });
}

function initSpreadsheetExportForm() {
  let form = document.forms['export_spreadsheet'];
  form.onsubmit = (e) => {
    e.preventDefault();
    insertProfileParamsIntoExportForm(form);
    insertTabsParamsIntoExportForm(form);
    form.submit();
  }
}

function insertProfileParamsIntoExportForm(form) {
  $('form#export_spreadsheet>input[name="profile_ids[]"]').remove();

  let profileIds = document.forms['profile-filter'].elements['profile_ids[]'];
  // When there's only one profile, #elements does not return an Array
  if (profileIds.constructor.name === 'HTMLInputElement') {
    profileIds = [profileIds];
  }

  for (let i = 0; i < profileIds.length; i++) {
    const input = profileIds[i];
    if (!input.checked) {
      continue;
    }

    let newInput = document.createElement('input');
    newInput.type = 'hidden';
    newInput.name = 'profile_ids[]';
    newInput.value = input.value;
    newInput.checked = input.checked;
    form.append(newInput);
  }
}

function insertTabsParamsIntoExportForm(form) {
  const selectedFundStatisticsTab = document.querySelector("[id$='-fund-statistics-tab'][aria-selected='true']");
  const selectedCumulativeCashflowTab = document.querySelector("[id$='-cumulative-cashflow-tab'][aria-selected='true']");
  const selectedAnnualCashflowTab = document.querySelector("[id$='-annual-cashflow-tab'][aria-selected='true']");

  form.elements['selected_fund_statistics_tab'].value = selectedFundStatisticsTab
    .id
    .slice(0, selectedFundStatisticsTab.id.search(/-/));
  form.elements['selected_cumulative_cashflow_tab'].value = selectedCumulativeCashflowTab
    .id
    .slice(0, selectedCumulativeCashflowTab.id.search(/-/));
  form.elements['selected_annual_cashflow_tab'].value = selectedAnnualCashflowTab
    .id
    .slice(0, selectedAnnualCashflowTab.id.search(/-/));
}
